module.exports = __webpack_public_path__ + "static/media/icSkyMessenger.79288e71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ecosystem/images/icSkyMessenger.svg
// module id = 1016
// module chunks = 0